import Image from "next/image";
import { useState } from "react";
import { zIndex } from "interfaces";
import { handleSnapShot } from "redux-share/actions/controller.actions";
import IMAGES from "../../../../../images/importImages";

const Snapshot = () => {
    const [loading, setLoading] = useState(false);

    return (
        <div
            className={`${!loading && "pl-cursor-pointer"} pl-bg-secondary-600 pl-rounded-[4px]`}
            style={{ zIndex: zIndex.snapshot }}
            onClick={() => {
                if (!loading) handleSnapShot(setLoading);
            }}
            onDoubleClick={(event: any) => event.stopPropagation()}
        >
            <div className="pl-flex pl-items-center pl-justify-center pl-gap-1 pl-py-1 pl-px-[6px]">
                <Image src={IMAGES.scissor} width={12} height={12} />
                <p className="pl-text-[12px] pl-text-white dark:pl-text-dark pl-font-medium">{loading ? "درحال ذخیره سازی" : "عکس گرفتن"}</p>
            </div>
        </div>
    );
};

export default Snapshot;
